<template>
  <i class="fa fa-lg fa-check-circle content-list-item-icon mr-2" :class="{ active: isRead }"></i>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('questionnaire');

export default {
  name: 'QuestionnairesReadIcon',
  props: {
    questionnaireId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['unreadIds']),
    isRead() {
      return !this.unreadIds.includes(this.questionnaireId);
    },
  },
};
</script>
